import { useState, useEffect } from 'react';
import { getApiBaseUrl } from '../../core/config/api';

export interface BuildingTypeFromApi {
  id: string;
  name: string;
  icon: string;
  color: string;
  /** Prix de base (€), depuis config_building.prix */
  prix?: number;
}

/**
 * Charge les types de bâtiments depuis la BDD (config_building, status = actif).
 * Utilisé par le menu contextuel carte et la modale bâtiments.
 */
export function useBuildingTypes(): { buildingTypes: BuildingTypeFromApi[]; loading: boolean } {
  const [buildingTypes, setBuildingTypes] = useState<BuildingTypeFromApi[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }
    const apiUrl = getApiBaseUrl();
    fetch(`${apiUrl}/api/buildings/types`, {
      headers: { Authorization: `Bearer ${token}` },
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setBuildingTypes(
            data.data.map(
              (row: { code: string; nom: string; icon?: string; couleur?: string; prix?: number }) => ({
                id: row.code,
                name: row.nom,
                icon: row.icon || '🏢',
                color: row.couleur || 'text-gray-400',
                prix: row.prix != null ? Number(row.prix) : undefined,
              })
            )
          );
        }
      })
      .catch(() => setBuildingTypes([]))
      .finally(() => setLoading(false));
  }, []);

  return { buildingTypes, loading };
}

export default useBuildingTypes;
